import { getCookies } from 'cookies-next';
import { OptionsType } from 'cookies-next/lib/types';
import { isString } from 'remeda';

import { getOsName } from '../get-os-name';
import { AppInfo } from '../shared.type';

/**
 * cookie에서 모든 appInfo를 가져옵니다.
 */
export const getAllCookieAppInfo = (options?: OptionsType): Partial<AppInfo> => {
  const {
    authorization,
    Authorization,
    'banksalad-api-env': apiEnv,
    'banksalad-application-name': applicationName,
    'banksalad-application-version': applicationVersion,
    'banksalad-build-type': buildType,
    'banksalad-device-id': deviceId,
    'banksalad-os-version': osVersion,
    'banksalad-release-type': releaseType,
    'banksalad-request-id': requestId,
    'banksalad-session-id': sessionId,
  } = getCookies(options);

  return {
    /**
     * - IOS의 경우 최초 개발시 PascalCase를 사용했기 때문에 Authorization fallback
     * 이 필요
     * - Android의 경우 Authorization을 쓰면 만료된 token 정보가 들어올 수 있음
     * - authorization ?? Authorization 순으로 조회순서를 강제필요
     *  관련 링크: https://banksalad.slack.com/archives/C045MMQUF9S/p1679383452927879?thread_ts=1679291903.002409&cid=C045MMQUF9S
     * */
    accessToken: authorization ?? Authorization,
    apiEnv,
    osName: isString(applicationName) ? getOsName(applicationName) : undefined,
    applicationVersion,
    buildType,
    deviceId,
    osVersion,
    releaseType,
    requestId,
    sessionId,
  };
};
